// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2022 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import { DealerStateContext } from "@insite/client-framework/Store/Data/Dealers/DealersSelectors";
import translate from "@insite/client-framework/Translate";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import { DealerDetailsPageContext } from "@insite/content-library/Pages/DealerDetailsPage";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import LazyImage, { LazyImageProps } from "@mcmc/MobiusOverrides/LazyImage";
import React, { useContext } from "react";
import { css } from "styled-components";

export interface DealerImageStyles {
    wrapper?: InjectableCss;
    image?: LazyImageProps;
}

export const dealerImageStyles: DealerImageStyles = {
    wrapper: {
        css: css`
            margin-top: 10px;
        `,
    },
};

const styles = dealerImageStyles;

const DealerImage: React.FC = () => {
    const { value: dealer } = useContext(DealerStateContext);

    if (!dealer) {
        return null;
    }

    if (dealer.properties && !dealer.properties.image) {
        return null;
    }

    return (
        <StyledWrapper {...styles.wrapper}>
            <LazyImage
                src={dealer.properties.image}
                altText={dealer.properties?.imageAltTag || translate("Dealer Image")}
                {...styles.image}
            />
        </StyledWrapper>
    );
};

const widgetModule: WidgetModule = {
    component: DealerImage,
    definition: {
        allowedContexts: [DealerDetailsPageContext],
        group: "Dealer Details",
    },
};

export default widgetModule;
